import { useRef, useState, useEffect } from 'react';
import 'react-awesome-lightbox/build/style.css';
import useUploadImage from '../../hooks/useUploadImage';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import {
  MainImage,
  RemoveImageBtn,
  ImageAndRemoveWrapper,
  NoImageContainer,
  PlusSymbol,
  SelectImageTxt,
  Wrapper,
  ProgressBarContainer,
  PuffLoaderContainer,
} from './styles';
import { primaryColor } from '../../config/colors';
import useGetImage from '../../hooks/useGetImage';
import PuffLoader from 'react-spinners/PuffLoader';
import useDeleteImage from '../../hooks/useDeleteImage';

const EditImageView = ({
  imageId,
  containerStyle,
  imageArrIndex = undefined,
  onImageUpload = () => {},
  onImageRemove = () => {},
  shouldSendDeleteImageReq = () => false,
  placeholderStyles = {
    plusIconSize: '100px',
    marginBetween: '0.5rem',
    textSize: '1.25rem',
  },
  deleteImmediately = false,
}) => {
  const { image: downloadedImage, isLoading: getImageLoading } = useGetImage(imageId);
  const [image, setImage] = useState(null);
  const inputFile = useRef(null);
  const { uploadImage, isLoading: isUploadLoading, uploadProgress } = useUploadImage();
  const { deleteImage } = useDeleteImage();

  const onWrapperClick = () => {
    if (!isUploadLoading) {
      inputFile.current.click();
    }
  };

  const onImageSelect = async (event) => {
    if (event.target.files[0]) {
      setImage(URL.createObjectURL(event.target.files[0]));
    }
    uploadImage(event.target.files[0], {
      onSuccess: (resData, imageFile) => onImageUpload(resData, imageFile, imageArrIndex),
    });
  };

  const handleImageRemove = (event) => {
    event.stopPropagation();
    setImage(null);
    if (imageArrIndex !== undefined) {
      if (shouldSendDeleteImageReq(imageId)) {
        deleteImage(imageId, { onSuccess: (resData, imageId) => onImageRemove(resData, imageId, imageArrIndex) });
      } else {
        onImageRemove(undefined, imageId, imageArrIndex);
      }
    } else {
      if (deleteImmediately) {
        deleteImage(imageId, { onSuccess: (resData, imageId) => onImageRemove(resData, imageId) });
      } else {
        onImageRemove(undefined, imageId);
      }
    }
  };

  useEffect(() => {
    if (!downloadedImage) {
      return;
    }
    const base64ImageData = `data:image/jpeg;base64,${downloadedImage.data}`;
    setImage(base64ImageData);
  }, [downloadedImage]);

  if (getImageLoading) {
    return (
      <PuffLoaderContainer containerStyle={containerStyle}>
        <PuffLoader
          loading={true}
          size={150}
          color={primaryColor}
        />
      </PuffLoaderContainer>
    );
  }

  if (isUploadLoading) {
    return (
      <ProgressBarContainer containerStyle={containerStyle}>
        <CircularProgressbar
          value={uploadProgress}
          text={`${uploadProgress}%`}
          strokeWidth={3}
          styles={{
            path: {
              stroke: primaryColor,
            },
            text: {
              fill: primaryColor,
              fontSize: '1rem',
            },
          }}
        />
      </ProgressBarContainer>
    );
  }

  return (
    <Wrapper
      style={containerStyle}
      onClick={onWrapperClick}>
      <input
        type='file'
        id='file'
        ref={inputFile}
        style={{ display: 'none' }}
        onChange={onImageSelect}
        accept='.png,.jpg,.jpeg'
      />
      {image ? (
        <ImageAndRemoveWrapper>
          <MainImage src={image} />
          <RemoveImageBtn onClick={handleImageRemove} />
        </ImageAndRemoveWrapper>
      ) : (
        <NoImageContainer>
          <PlusSymbol size={placeholderStyles?.plusIconSize} />
          <SelectImageTxt
            style={{
              fontSize: placeholderStyles?.textSize,
              marginTop: placeholderStyles?.marginBetween,
            }}>
            Select Image
          </SelectImageTxt>
        </NoImageContainer>
      )}
    </Wrapper>
  );
};

export default EditImageView;
